import * as React from "react"
import { Box } from "@mui/material"

import { DateRangeBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { stockChangesDateRange } from "./Ranges"
import { stockChangesCurrentPeriod } from "../@signals"


export default function StockChangesPriceEvolutionChartToolbar({dateRange, onChange }) {
    return <Box display="flex" gap={2} alignItems="center">
        <DateRangeBlock
            currentPeriodLabel={stockChangesCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={stockChangesDateRange}
            onChange={onChange}
            onOk={() => stockChangesCurrentPeriod.value = DATE_PERIODS.CUSTOM}
        />
    </Box>
}